import { render, staticRenderFns } from "./FilePreview.vue?vue&type=template&id=20c156b0&scoped=true&"
import script from "./FilePreview.vue?vue&type=script&lang=js&"
export * from "./FilePreview.vue?vue&type=script&lang=js&"
import style0 from "./FilePreview.vue?vue&type=style&index=0&id=20c156b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c156b0",
  null
  
)

export default component.exports